
import React from 'react';
import './RegisterPage.css';
import { register } from '../../redux/authentication/authentication_actions';
import { connect } from 'react-redux';
import logoImage from '../../assets/images/2e-building.png';

class RegisterSuccessPage extends React.Component {
  constructor(props) {
    super(props);
  }

  backToLogin() {
    this.props.history.push('/');
  }

  render() {
    return (
      <div className="zenregister">
        <div className="register-container">
          <div className="register-header">
            <img style={{ width: '100%' }} src={logoImage} />
            <a style={{ fontSize: 20, paddingTop: 10 }} href="#">Building Energy Code</a>
          </div>

          <div className="register-content">
            <div
              className="form-actions form-group js-form-wrapper form-wrapper"
            >
              <button
                onClick={this.backToLogin.bind(this)}
                type="button"
                className="button btn icon-before"
              >
                <span
                  className="icon glyphicon glyphicon glyphicon-menu-left"
                  aria-hidden="true"
                />
                Back to login
              </button>
              <div className="alert alert-success" id="edit-invalid" >Registered successfully! Please click on the Activation Link to Activate your account.</div>
            </div>
          </div>

          <div className="register-footer">
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
)(RegisterSuccessPage);



// WEBPACK FOOTER //
// ./src/pages/register/RegisterSuccessPage.js